import { render, staticRenderFns } from "./NotificationAppointmentRequested.vue?vue&type=template&id=4406c332&scoped=true&"
import script from "./NotificationAppointmentRequested.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentRequested.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406c332",
  null
  
)

export default component.exports